<template>
    <div class="eventPresetView innerMainContent">
        <div class="innerHeader">
            <div class="h1Wrap">
                <svg class="i_calender"><use xlink:href="#i_calender"></use></svg>
                <div class="innerH1Wrap">
                    <h1>{{ event.name }}</h1>
                    <ul class="breadcrumb">
                        <li><router-link to="/">{{ $t('menu_hp') }}</router-link></li>
                        <li><router-link v-bind:to="'/event/wedding/'+event.id">{{ $t('event') }}</router-link></li>
                        <li class="active">{{ event.name }}</li>
                    </ul>
                </div>
            </div>
            <div class="editEventActions">
                <button v-if="false" class="noteEvent">
                    <svg class="i_note"><use xlink:href="#i_plus"></use></svg>
                    <span>{{ $t('notes') }}</span>
                </button>
                <button class="deleteEvent">
                    <svg class="i_delete"><use xlink:href="#i_trash"></use></svg>
                    <span>{{ $t('deleteEvent_2') }}</span>
                </button>

                <button class="deleteEvent" @click="savePresetScreenShot" :disabled="savingPresetScreenshot">
                    <svg class="i_delete"><use xlink:href="#i_template"></use></svg>
                    <span>{{ $t(savingPresetScreenshot ? 'pleaseWait' : 'saveScreenShot') }}</span>
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-xs-12 matchHeight eventSummary">
                <div class="innerBox">
                    <div class="eventInfoWrapper">
                        <h2>
                            <svg class="i_couple"><use xlink:href="#i_couple"></use></svg>
                            <span>
                                <div>{{ event.name }}</div>
                                <div class="date">{{ event.dateStr }}</div>
                            </span>
                        </h2>
                        <ul class="mainInfo">
                            <li>
                                <svg class="i_location"><use xlink:href="#i_location"></use></svg>
                                <span class="liTitle">{{ $t('hall') }}:</span>
                                <span>{{ event.hall.name }}</span>
                            </li>
                            <li>
                                <svg class="i_users"><use xlink:href="#i_users"></use></svg>
                                <span class="liTitle">{{ $t('guestsNum') }}:</span>
                                <span>{{ getTotalGuests() }}</span>
                            </li>
                        </ul>
                        <ul class="moreInfo">
                            <li>
                                <h3>{{ $t('hostName') }}</h3>
                                <div></div>
                            </li>
                            <li>
                                <h3>{{ $t('name') }}</h3>
                                <div>{{ event.owner.name }}</div>
                            </li>
                            <li>
                                <h3>{{ $t('phone') }}</h3>
                                <div>{{ event.owner.phone }}</div>
                            </li>
                            <li>
                                <h3>{{ $t('email') }}</h3>
                                <div>{{ event.owner.email }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-xs-12 matchHeight">
                <div class="innerBox pieWrapper">
                    <div class="pieInnerWrapper">
                        <h2>{{ $t('guests') }}</h2>
                        <ul data-pie-id="pie-svg">
                            <li v-bind:data-value="getGuestsPercent(guests.notResponded).toString()" class="notResponded"><span><span class="precent">{{ getGuestsPercent(guests.notResponded) }}%</span> {{ $t('ofGuests') }} <span class="status">{{ $t('notResponded') }}</span></span></li>
                            <li v-bind:data-value="getGuestsPercent(guests.coming).toString()" class="respondedPositive"><span><span class="precent">{{ getGuestsPercent(guests.coming) }}%</span> {{ $t('ofGuests') }} <span class="status">{{ $t('willCome') }}</span> {{ $t('toEvent') }}</span></li>
                            <li v-bind:data-value="getGuestsPercent(guests.maybe).toString()" class="respondedMaybe"><span><span class="precent">{{ getGuestsPercent(guests.maybe) }}%</span> {{ $t('ofGuests') }} <span class="status">{{ $t('mayCome') }}</span> {{ $t('willCome') }} {{ $t('toEvent') }}</span></li>
                            <li v-bind:data-value="getGuestsPercent(guests.notComing).toString()" class="respondedNegative"><span><span class="precent">{{ getGuestsPercent(guests.notComing) }}%</span> {{ $t('ofGuests') }} <span class="status">{{ $t('notComing') }}</span> {{ $t('toEvent') }}</span></li>
                            <li v-bind:data-value="getGuestsPercent(guests.reserve).toString()" class="respondedNegative"><span><span class="precent">{{ getGuestsPercent(guests.reserve) }}%</span> {{ $t('ofGuests') }} <span class="status">{{ $t('reserve') }}</span> {{ $t('toEvent') }}</span></li>

                        </ul>
                    </div>
                    <div id="pie-svg"></div>

                </div>
            </div>
        </div>
        <div class="bottomPart">
            <div class="row">
                <div class="col-md-4">
                    <div class="innerBox ulamDetailes">
                        <h2>{{ $t('sittingArrangements') }} <span class="placeNumbers">(<span class="ulamCapacity">{{ getTotalGuests() }}</span>)</span><svg class="i_info"><use xlink:href="#i_info"></use></svg></h2>
                        <div class="inputWrap" v-if="presets.length >0">
                            <label for="presetType">{{ $t('choosePreset') }}</label>
                            <div class="selectWrap">
                                <select name="presetType" id="presetType" @change="setPreset" v-model="selectedPreset">
                                    <option v-for="preset of presets" v-bind:value="preset.id" v-bind:data-places="preset.capacity">{{ preset.name }}</option>
                                </select>
                                <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                            </div>
                        </div>
                        <div class="checkboxWrap">
									<span class="checkboxInnerWrap">
										<input id="lockPresetCheckBox" type="checkbox" :checked="(this.event.presetLocked ? 'checked' : '')" @click="setPresetLock">
										<span class="checkS"></span>
										<svg class="i_v"><use xlink:href="#i_v"></use></svg>
									</span>
                            <label>{{ $t('disablePresetChanges') }}</label>
                        </div>
                        <div class="checkboxWrap">
									<span class="checkboxInnerWrap">
										<input type="checkbox" :checked="(this.inGridMode ? 'checked' : '')" @click="useGrid()">
										<span class="checkS"></span>
										<svg class="i_v"><use xlink:href="#i_v"></use></svg>
									</span>
                            <label>{{ $t('useGridMode') }}</label>
                        </div>
                        <div class="checkboxWrap">
									<span class="checkboxInnerWrap">
										<input type="checkbox" :checked="(this.event.groupSeating ? 'checked' : '')" @click="useGroupSeating()">
										<span class="checkS"></span>
										<svg class="i_v"><use xlink:href="#i_v"></use></svg>
									</span>
                            <label>{{ $t('useGroupSeating') }}</label>
                        </div>
                        <div class="checkboxWrap">
									<span class="checkboxInnerWrap">
										<input id="strictTablesCheckbox" type="checkbox" :checked="(this.event.strictTables ? 'checked' : '')" @click="setStrictTables">
										<span class="checkS"></span>
										<svg class="i_v"><use xlink:href="#i_v"></use></svg>
									</span>
                            <label>{{ $t('strictTables') }}</label>
                        </div>
                        <div class="checkboxWrap">
									<span class="checkboxInnerWrap">
										<input id="resevedSeatingAllowedCheckbox" type="checkbox" :checked="(this.event.resevedSeatingAllowed ? 'checked' : '')" @click="setAllowReservedSeating">
										<span class="checkS"></span>
										<svg class="i_v"><use xlink:href="#i_v"></use></svg>
									</span>
                            <label>{{ $t('resevedSeatingAllowed') }}</label>
                        </div>
                        <div class="panel-group" id="moreFieldsAcc">

                            <div class="panel panel-default ">
                                <div class="panel-heading accordion-toggle question-toggle collapsed" data-toggle="collapse" data-parent="#moreFieldsAcc" data-target="#inputGroup2">
                                    <h4 class="panel-title">
                                        <a href="#" @click.prevent="">{{ $t('tableType') }}</a>
                                        <svg class="i_plus_2"><use xlink:href="#i_plus_2"></use></svg>
                                        <svg class="i_minus"><use xlink:href="#i_minus"></use></svg>
                                    </h4>
                                </div>
                                <div id="inputGroup2" class="panel-collapse collapse">
                                    <div class="panel-body">
                                        <div id="dragablleItems" style="height:400px;overflow-y: scroll">
													<span class="item matchHeight">
														<div class="tableWrap squareTable" data-capacity="12" data-type="table" data-shape="square">
															<div class="square"></div>
														</div>
														<div class="itemLabel">{{ $t('square') }}</div>
													</span>
                                            <span class="item matchHeight">
														<div class="tableWrap circleTable" data-capacity="12" data-type="table" data-shape="circle">
															<div class="circle"></div>
														</div>
														<div class="itemLabel">{{ $t('circle') }}</div>
													</span>
                                            <span class="item matchHeight">
														<div class="tableWrap rectangleTable" data-tablehead="2" data-capacity="12" data-type="table" data-shape="rectangle">
															<div class="rectangle"></div>
														</div>
														<div class="itemLabel">{{ $t('rectangle') }}</div>
													</span>
                                            <span class="item matchHeight">
														<div class="tableWrap rectangleTable ellipseTable" data-tablehead="1" data-capacity="12" data-type="table" data-shape="ellipse">
															<div class="rectangle"></div>
														</div>
														<div class="itemLabel">{{ $t('ellipse') }}</div>
													</span>
                                           <!-- <span class="item matchHeight">
														<div class="imgWrap" data-type="table" data-capacity="12" data-shape="drop">
															<img src="/static/images/drop.png">
														</div>
														<div>{{ $t('drop') }}</div>
													</span>-->

                                            <span class="item matchHeight">
														<div class="tableWrap squareTable wood" data-capacity="12" data-type="table" data-shape="square">
															<div class="square"></div>
														</div>
														<div class="itemLabel">{{ $t('wood') }}</div>
													</span>

                                            <span class="item matchHeight" v-for="table of $store.state.tables">
                                                <div class="tableWrap" v-bind:data-side1="table.side1 ? table.side1 : ''" v-bind:data-side2="table.side2 ? table.side2 : ''" v-bind:data-side3="table.side3 ? table.side3 : ''" v-bind:data-side4="table.side4 ? table.side4 : ''" v-bind:class="table.shape != 'drop' ? (table.shape == 'wood' ?  'squareTable ' + table.shape : (table.shape == 'ellipseTable' ? 'rectangleTable ' + table.shape : table.shape)) : ''" v-bind:data-capacity="table.capacity" data-type="table" v-bind:data-shape="getShape(table.shape)" v-bind:data-tablehead="(table.shape == 'rectangleTable' ? (Math.round((table.capacity/4)/2)) : (table.shape == 'ellipseTable' ? 1 : ''))">
															<div v-if="table.shape !='drop'" v-bind:class="table.shape != 'ellipseTable' ? getShape(table.shape) : 'rectangle'"></div>
															<img v-if="table.shape == 'drop'" src="/static/images/drop.png">
                                                </div>
                                                <div class="itemLabel">{{ table.title }}</div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default ">
                                <div class="innerPannel">
                                    <div class="panel-heading accordion-toggle question-toggle collapsed" data-toggle="collapse" data-parent="#moreFieldsAcc" data-target="#inputGroup3">
                                        <h4 class="panel-title">
                                            <a href="#" @click.prevent="">{{ $t('tools') }}</a>
                                            <svg class="i_plus_2"><use xlink:href="#i_plus_2"></use></svg>
                                            <svg class="i_minus"><use xlink:href="#i_minus"></use></svg>
                                        </h4>
                                    </div>
                                    <div id="inputGroup3" class="panel-collapse collapse">
                                        <div class="panel-body">
                                            <ul>
                                                <li class="matchHeight" @click="copyItems">
                                                    <div class="imgWrap">
                                                        <svg class="svg_icon"><use xlink:href="#i_copy"></use></svg>
                                                    </div>
                                                    <div>{{ $t('copy') }}</div>
                                                </li>
                                                <li class="matchHeight" @click="autoNum">
                                                    <div class="imgWrap">
                                                        <svg class="svg_icon"><use xlink:href="#i_coffee_table"></use></svg>
                                                    </div>
                                                    <div>{{ $t('autoNum') }}</div>
                                                </li>

                                                <li class="matchHeight" @click="resetPreset">
                                                    <div class="imgWrap">
                                                        <svg class="svg_icon"><use xlink:href="#i_trash"></use></svg>
                                                    </div>
                                                    <div>{{ $t('resetPreset') }}</div>
                                                </li>

                                                <li class="matchHeight" @click="saveAsTemplate">
                                                    <div class="imgWrap">
                                                        <svg class="svg_icon"><use xlink:href="#i_template"></use></svg>
                                                    </div>
                                                    <div>{{ $t('saveAsTemplate') }}</div>
                                                </li>

                                                <li class="matchHeight" @click="setTablesReserving">
                                                    <div class="imgWrap">
                                                        <svg class="svg_icon"><use xlink:href="#i_offer_tab"></use></svg>
                                                    </div>
                                                    <div>{{ $t('markAsReserved') }}</div>
                                                </li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="panel panel-default ">
                                <div class="panel-heading accordion-toggle question-toggle collapsed" data-toggle="collapse" data-parent="#moreFieldsAcc" data-target="#inputGroup1">
                                    <h4 class="panel-title">
                                        <a href="#" @click.prevent="">{{ $t('equipment') }}</a>
                                        <svg class="i_plus_2"><use xlink:href="#i_plus_2"></use></svg>
                                        <svg class="i_minus"><use xlink:href="#i_minus"></use></svg>
                                    </h4>
                                </div>
                                <div id="inputGroup1" class="panel-collapse collapse">
                                    <div class="panel-body">
                                        <div id="dragablleItems_2">
													<span class="item matchHeight">
														<div class="imgWrap" data-type="bama">
															<img src="/static/images/bama.png">
														</div>
														<div class="itemLabel">{{ $t('bama') }}</div>
													</span>
                                            <span class="item matchHeight">
														<div class="imgWrap" data-type="bar">
															<img src="/static/images/bar.png">
														</div>
														<div class="itemLabel">{{ $t('bar') }}</div>
													</span>
                                            <span class="item matchHeight">
														<div class="imgWrap" data-type="hupa">
															<img src="/static/images/hupa.png">
														</div>
														<div class="itemLabel">{{ $t('hupa') }}</div>
													</span>
                                            <span class="item matchHeight">
														<div class="imgWrap" data-type="bufe">
															<img src="/static/images/bufe.png">
														</div>
														<div class="itemLabel">{{ $t('bufe') }}</div>
													</span>
                                            <span class="item matchHeight">
														<div class="imgWrap" data-type="mehiza">
															<img src="/static/images/mehiza.png">
														</div>
														<div class="itemLabel">{{ $t('mehiza') }}</div>
													</span>
                                            <span class="item matchHeight" v-for="equipment of $store.state.equipments">
                                                <div class="tableWrap" v-bind:class="equipment.shape != 'drop' ? (equipment.shape == 'wood' ?  'squareTable ' + equipment.shape : (equipment.shape == 'ellipseTable' ? 'rectangleTable ' + equipment.shape : equipment.shape)) : ''" data-type="equipment" v-bind:data-shape="getShape(equipment.shape)" >
															<div v-if="equipment.shape !='drop'" v-bind:class="equipment.shape != 'ellipseTable' ? getShape(equipment.shape) : 'rectangle'"></div>
															<img v-if="equipment.shape == 'drop'" src="/static/images/drop.png">
                                                </div>
                                                <div class="itemLabel">{{ equipment.title }}</div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="row">
                        <div class="col-md-4 matchHeight" v-if="!$store.state.isTablet">
                            <div v-bind:class="!$store.state.isTablet ? 'totalSeats' : ''">
                                <div class="innerTotalSeats">
                                    <div>
                                        <span class="ulamCapacity">{{ getSeats('all') }}</span><span>{{ $t('total') }}</span>
                                    </div>
                                    <div>{{ $t('hallPlaces') }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 matchHeight">
                            <div class="innerBox precentageWrap seatedPlaces">
                                <div class="circlePrecWrap ">
                                    <svg viewBox="0 0 36 36" class="circular-chart">
                                        <path class="circle-bg" d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                                        <path class="circle" stroke-dasharray="0, 100" v-bind:stroke-dasharray="(isNaN(((isNaN(Math.round((getSeats('taken')/getSeats('seats'))*100)) ? 0 : Math.round((getSeats('taken')/getSeats('seats'))*100)))) ? 0 : ((isNaN(Math.round((getSeats('taken')/getSeats('seats'))*100)) ? 0 : Math.round((getSeats('taken')/getSeats('seats'))*100)))) + ', 100'" d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                                        <text x="18" y="20.35" class="percentage">{{ (isNaN(Math.round((getSeats('taken')/getSeats('seats'))*100)) ? 0 : Math.round((getSeats('taken')/getSeats('seats'))*100)) }}%</text>
                                    </svg>
                                </div>
                                <div class="precentageTxt">
                                    <div class="precentageIcon"><span class="mainIcon"></span> <span></span></div>
                                    <div class="placesNum">{{ getSeats('taken') }}</div>
                                    <div class="seatedStatus">{{ $t('taken') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 matchHeight">
                            <div class="innerBox precentageWrap unSeatedPlaces">
                                <div class="circlePrecWrap ">
                                    <svg viewBox="0 0 36 36" class="circular-chart">
                                        <path class="circle-bg" d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                                        <path class="circle" stroke-dasharray="0, 100" v-bind:stroke-dasharray="(isNaN(((isNaN(Math.round((getSeats('available')/getSeats('seats'))*100)) ? 0 : Math.round((getSeats('available')/getSeats('seats'))*100)))) ? 0 : ((isNaN(Math.round((getSeats('available')/getSeats('seats'))*100)) ? 0 : Math.round((getSeats('available')/getSeats('seats'))*100)))) + ', 100'" d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                                        <text x="18" y="20.35" class="percentage">{{ (isNaN(Math.round((getSeats('available')/getSeats('seats'))*100)) ? 0 : Math.round((getSeats('available')/getSeats('seats'))*100)) }}%</text>
                                    </svg>
                                </div>
                                <div class="precentageTxt">
                                    <div class="precentageIcon"><span class="mainIcon"></span> <span></span></div>
                                    <div class="placesNum">{{ getSeats('available') }}</div>
                                    <div class="seatedStatus">{{ $t('available') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12" style="height:30px">
                            <div class="controlBar">
                                <span class="right">{{ $t('rollbackNote') }}</span>
                                <button class="deleteEvent" v-if="tablesNumbering" @click="tablesNumbering=false">{{ $t('endNumbering') }}</button>
                                <button class="deleteEvent" v-if="tablesReserving" @click="tablesReserving=false">{{ $t('endReserving') }}</button>
                                <button class="deleteEvent" v-if="!selectMode" @click="selectMode=true">{{ $t('startSelecting') }}</button>
                                <button class="deleteEvent" v-if="selectMode" @click="finishSelectMode">{{ $t('finish') }}</button>
                            </div>
                        </div>
                    </div>
                    <div class="ulamLayoutWrapper">
                        <div id="ulamLayout" v-bind:style="'background-image:url(\''+event.preset.background+'\')'">
                            <div class="grid" id="gridWrap">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import html2canvas from 'html2canvas';
    import Config from '../../Config'
    export default {
        name: 'EventPreset',
        data() {
            return {
                selectMode:false,
                savingPresetScreenshot:false,
                inGridMode:false,
                controlPressed:false,
                tablesNumbering:false,
                tablesReserving:false,
                autoNumStart:1,
                selected:[],
                event:{hall:{},owner:{},preset:{},presetData:[],guests:[]},
                presets:[],
                selectedPreset:0,
                guests:{
                    notResponded:0,
                    coming:0,
                    maybe:0,
                    notComing:0,
                    reserve:0
                },
                draggedItem:{dbID:'',startPosition:{left:0,top:0}}
            }
        },
        components:{
        },
        watch:{
            controlPressed:function(_){
                if(_){
                    this.selectMode = true;
                }else{
                    if(!this.selected.length) this.selectMode = false;
                }
            }
        },
        mounted(){
            this.initRollbackEngine();
            this.initKeyboardMovements();
        },
        beforeMount(){
            this.$store.dispatch('getTables')
            this.$store.dispatch('getEquipments')
            //check permissions
            if(this.$store.state.user.type != 2){
                this.$router.push('/');
            }

            let eventID = parseInt(this.$router.currentRoute.params.id);

            if(eventID == '' || eventID == 0) this.$router.push('/')

            //fetch event and preset
            window.liveIsBetter = true;
            this.$store.dispatch('getEvent',eventID)
                .then(response =>{
                    //success
                    this.event = response.data
                    this.inGridMode = this.event.inGridMode
                    if(!this.$store.state.isTablet) $(".matchHeight").matchHeight();

                    this.$store.dispatch('getGuests',this.event.id)
                        .then(response =>{
                            //success
                            this.event.guests = response.data;
                            this.calculateGuests();
                        })
                        .catch(err => {
                            //err
                            this.$router.push('/');
                            this.$swal({
                                confirmButtonText:this.$t('okButton'),
                                type:'error',
                                title:this.$t('fatalError'),
                                timer:3000
                            }).catch(this.$swal.noop);
                        })

                    //get hall presets
                    this.$store.dispatch('getPreset','hall/' + response.data.hall.id)
                        .then(response =>{
                            //success
                            this.presets = response;
                            this.selectedPreset = this.event.preset.id;
                            this.initiate()
                        })
                })
                .catch(err => {
                    //err
                    this.$router.push('/');
                    this.$swal({
                        confirmButtonText:this.$t('okButton'),
                        type:'error',
                        title:this.$t('fatalError'),
                        timer:3000
                    }).catch(this.$swal.noop);

                })
        },
        beforeDestroy(){
            $(document).ready(function(){
                $(document).off('keydown')
            })
        },
        methods:{
            /*initLayoutSize(){
                this.width = document.querySelector('.ulamLayoutWrapper').getBoundingClientRect().width;
                this.height = document.querySelector('.ulamLayoutWrapper').getBoundingClientRect().width;
            },*/
            getGuestsPercent(sum){
                let _ = Math.round((sum/this.getTotalGuests())*100);
                return isNaN(_) ? 0 : _;
            },
            getTotalGuests(){
                return (this.guests.coming+this.guests.maybe+this.guests.notComing+this.guests.notResponded+this.guests.reserve);
            },
            calculateGuests(){
                if(this.event.guests.length > 0 ){
                    for(let guest of this.event.guests){
                        if(typeof guest.status ==='object'){
                            this.guests.notResponded += guest.status.notResponded;
                            this.guests.maybe += guest.status.maybeComing;
                            this.guests.coming += guest.status.coming;
                            this.guests.notComing += guest.status.notComing;
                            this.guests.reserve += guest.status.reserve;
                        }
                    }
                }
            },
            initiate(){
                let _this = this;
                $(document).ready(function(){
                    $.getScript( "/static/js/sortable.min.js",function(){
                        $.getScript( "/static/js/pie.min.js",function(){
                            $.getScript( "/static/js/dependencies.js",function(){
                                _this.initJS();
                            });
                        });
                    });
                });
            },
            getSeatsStatusForTable(id = ''){
                let status = {
                    confirmed:0,
                    notComing:0,
                    maybeComing:0,
                    notResponded:0,
                    reserve:0,
                };

                if(typeof id ==='undefined' || id == '' || !id) return status;
                if(this.event.guests.length > 0) {
                    for (let guest of this.event.guests) {
                        if(guest.tableID == id && typeof guest.status ==='object'){
                            status.confirmed += guest.status.coming;
                            status.maybeComing += guest.status.maybeComing;
                            status.reserve += guest.status.reserve;
                            status.notComing += guest.status.notComing;
                            status.notResponded += guest.status.notResponded;
                        }
                    }
                }

                return status;

            },
            getSeatClass(status = ''){
                switch(status){
                    case 'confirmed':
                        return 'confirmed'
                        break;
                    case 'notComing':
                        return 'notComing'
                        break;
                    case 'maybeComing':
                        return 'maybe'
                        break;
                    case 'notResponded':
                        return 'notResponded'
                        break;
                    case 'reserve':
                        return 'reserve'
                        break;
                    default:
                        return '';
                        break;
                }
            },
            getSeatsHtml(seatsStatus = {}, capacity = 0){
                let seats = [];
                for(let status in seatsStatus) {
                    let status_places = seatsStatus[status]
                    if (status_places > 0) {
                        for(let s = 1;s<=status_places;s++){
                            let seat = "<span class='seat " + this.getSeatClass(status) + "'></span>";
                            seats.push( seat );
                        }
                    }
                }
                for(let s = seats.length;s<=capacity-1;s++){
                    let seat = "<span class='seat " + this.getSeatClass('') + "'></span>";
                    seats.push( seat );
                }
                return seats;
            },
            setLayout(layout, isRestore = false){
                if(!isRestore) this.saveRollBack(layout);

                let badPositionItems = 1;
                if(layout.elements.length > 0){
                    for(let item of layout.elements){
                        item.occupiedPlaces = 0;
                        if(this.event.guests.length > 0){
                            if(item.type == 'table') {
                                try{
                                    let x = item.position.x.replace("px","");
                                    let y = item.position.y.replace("px","");

                                    if(x < 0 || y < 0) {
                                        badPositionItems++;
                                        item.position.x = `${0}px`;
                                        item.position.y = `${badPositionItems*40}px`;
                                    }

                                } catch (e){

                                }
                                for (let guest of this.event.guests) {
                                    if (guest.tableID == item.dbID && typeof guest.status === 'object') {
                                        item.occupiedPlaces += guest.status.coming;
                                    }
                                }
                            }
                        }
                    }
                }

                let _this = this;
                $('#gridWrap').html('');
                let message = typeof layout === 'object' ? layout : JSON.parse(layout);
                $.each(message.elements, function (index, element) {
                    let item = "";
                    if(!element.dbID) element.dbID = window.guid();

                    const tableNumRotation = (element.rotation ? (element.rotation > 0 ? 0-element.rotation : Math.abs(element.rotation)) : 0);

                    let elmBackup = {};
                    let isReserved = element.hasOwnProperty("reserved") && element.reserved === true;
                    if(element.type === "table"){
                        elmBackup = Object.assign({},element);
                        if(isReserved) element.tableNum = `${_this.$t('reserved')}${element.tableNum}`;
                        let tablehead = 0,
                            tableClass="",
                            shapeClass = "";
                        switch (element.shape){
                            case "circle" :
                                tablehead = 0;
                                tableClass = "circleTable";
                                shapeClass = "circle";
                                break;
                            case "square" :
                                tablehead = 0;
                                tableClass = "squareTable";
                                shapeClass = "square";
                                break;
                            case "rectangle" :
                                tablehead = (Math.round((element.tableCapcity/4)/2));
                                tableClass = "rectangleTable";
                                shapeClass = "rectangle";
                                break;
                            case "ellipse" :
                                tablehead = 1;
                                tableClass = "rectangleTable ellipseTable";
                                shapeClass = "rectangle";
                                break;
                        }
                        let scale = 'transform:scale('+(element.scale ? element.scale : 1)+')';
                        scale = scale + ' rotate('+(element.rotation ? element.rotation : 0)+'deg);';

                        let _seated = _this.getSeatsStatusForTable(element.dbID);
                        let tableUsage = '';
                        if(typeof _seated ==='object'){
                            _seated = Object.values(_seated).reduce((a, b) => a + b)

                            tableUsage = `${_seated}/${element.tableCapcity}`;

                        }

                        if(element.shape =='drop'){
                            item = '<span data-reserved="'+(isReserved ? 'true' : false) +'" data-side1="'+(element.side1 ? element.side1 : '')+'" data-side2="'+(element.side2 ? element.side2 : '')+'" data-side3="'+(element.side3 ? element.side3 : '')+'" data-side4="'+(element.side4 ? element.side4 : '')+'" data-rotation="'+(element.rotation ? element.rotation : 0)+'" data-scale="'+(element.scale ? element.scale : 1)+'" class="item" style="'+scale+';top:'+element.position.y+';left:'+element.position.x+';"><div data-table-usage="'+tableUsage+'" data-shape="'+element.shape+'" data-dbid="'+element.dbID+'" class="tableWrap '+tableClass+'" data-tablehead="'+tablehead+'" data-capacity="'+element.tableCapcity+'" data-occupiedplaces="'+element.occupiedPlaces+'" data-type="table"><div class="'+shapeClass+'"><img src="/static/images/drop.png"><span class="tableNum" ' + (tableNumRotation !== 0 ? 'style="transform:rotate('+tableNumRotation+'deg);display:block"' : '') +'>'+element.tableNum+'</span></span></div></div><div class="resizeIcon"><i class="la la-arrows"></i></div><div class="rotateIcon"><i class="la la-rotate-left"></i></div><div class="deleteIcon"><i class="la la-trash-o"></i></div><div class="editIcon"><i class="la la-pencil"></i></div></span>';
                        }else{
                            item = '<span data-reserved="'+(isReserved ? 'true' : false) +'" data-side1="'+(element.side1 ? element.side1 : '')+'" data-side2="'+(element.side2 ? element.side2 : '')+'" data-side3="'+(element.side3 ? element.side3 : '')+'" data-side4="'+(element.side4 ? element.side4 : '')+'" data-rotation="'+(element.rotation ? element.rotation : 0)+'" data-scale="'+(element.scale ? element.scale : 1)+'" class="item" style="'+scale+';top:'+element.position.y+';left:'+element.position.x+';"><div data-table-usage="'+tableUsage+'" data-shape="'+element.shape+'" data-dbid="'+element.dbID+'" class="tableWrap '+tableClass+'" data-tablehead="'+tablehead+'" data-capacity="'+element.tableCapcity+'" data-occupiedplaces="'+element.occupiedPlaces+'" data-type="table"><div class="'+shapeClass+'"><span class="tableNum" ' + (tableNumRotation !== 0 ? 'style="transform:rotate('+tableNumRotation+'deg);display:block"' : '') +'>'+element.tableNum+'</span></span></div></div><div class="resizeIcon"><i class="la la-arrows"></i></div><div class="rotateIcon"><i class="la la-rotate-left"></i></div><div class="deleteIcon"><i class="la la-trash-o"></i></div><div class="editIcon"><i class="la la-pencil"></i></div></span>';
                        }

                    }else{
                        let scale = 'transform:scale('+(element.scale ? element.scale : 1)+')';
                        scale = scale + ' rotate('+(element.rotation ? element.rotation : 0)+'deg);';
                        if(element.type == "mehiza" || element.type == "bama" || element.type == "bar" || element.type == "bufe" || element.type == "hupa") {
                            item = '<span title="'+(typeof element.text !=='undefined' && element.text != '' ? element.text : '')+'" data-rotation="' + (element.rotation ? element.rotation : 0) + '" data-scale="' + (element.scale ? element.scale : 1) + '" class="item" style="' + scale + ';top:' + element.position.y + ';left:' + element.position.x + ';"><div data-shape="' + element.shape + '" data-dbid="' + element.dbID + '" data-type="' + element.type + '" class="imgWrap"><img src="/static/images/' + element.type + '.png"></div><div class="resizeIcon"><i class="la la-arrows"></i></div><div class="rotateIcon"><i class="la la-rotate-left"></i></div><div class="deleteIcon"><i class="la la-trash-o"></i></div><div class="editIcon"><i class="la la-pencil"></i></div>' + (typeof element.text !=='undefined' && element.text !== "" ? '<div class="itemLabel">'+element.text+'</div>' : '') + '</span>';
                        }else{
                            item = '<span title="'+(typeof element.text !=='undefined' && element.text != '' ? element.text : '')+'" class="item" data-rotation="' + (element.rotation ? element.rotation : 0) + '" data-scale="' + (element.scale ? element.scale : 1) + '" style="' + scale + ';top:' + element.position.y + ';left:' + element.position.x + ';"><div data-type="equipment" data-shape="'+element.shape+'" data-dbid="'+element.dbID+'" class="tableWrap '+(element.shape === 'ellipse' ? 'rectangleTable ellipse' : element.shape)+'Table"><div class="'+(element.shape === 'ellipse' ? 'rectangle' : element.shape)+'"></div></div><div class="resizeIcon"><i class="la la-arrows"></i></div><div class="rotateIcon"><i class="la la-rotate-left"></i></div><div class="deleteIcon"><i class="la la-trash-o"></i></div>' + (typeof element.text !=='undefined' && element.text !== "" ? '<div class="itemLabel">'+element.text+'</div>' : '') + '</span>';
                        }

                    }
                    $('#gridWrap').append(item);
                    if(isReserved) element.tableNum = elmBackup.tableNum || "";
                });
                $(".squareTable").each(function() {
                    let capacity  = $(this).data("capacity"),
                        capacityPerSide = capacity/4,
                        size = capacityPerSide * 14,
                        text = "";

                    let sides = {};
                    if(typeof $(this).data('side1') !== 'undefined' && $(this).data('side1') !== "") {
                        sides = {
                            side0: (typeof $(this).data('side1') !== 'undefined' && $(this).data('side1') != '' ? $(this).data('side1') : ''),
                            side1: (typeof $(this).data('side2') !== 'undefined' && $(this).data('side2') != '' ? $(this).data('side2') : ''),
                            side2: (typeof $(this).data('side3') !== 'undefined' && $(this).data('side3') != '' ? $(this).data('side3') : ''),
                            side3: (typeof $(this).data('side4') !== 'undefined' && $(this).data('side4') != '' ? $(this).data('side4') : ''),
                        };
                    }else {
                        sides = {
                            side0: (typeof $(this).parent().data('side1') !== 'undefined' && $(this).parent().data('side1') != '' ? $(this).parent().data('side1') : ''),
                            side1: (typeof $(this).parent().data('side2') !== 'undefined' && $(this).parent().data('side2') != '' ? $(this).parent().data('side2') : ''),
                            side2: (typeof $(this).parent().data('side3') !== 'undefined' && $(this).parent().data('side3') != '' ? $(this).parent().data('side3') : ''),
                            side3: (typeof $(this).parent().data('side4') !== 'undefined' && $(this).parent().data('side4') != '' ? $(this).parent().data('side4') : ''),
                        };
                    }

                    let seats = _this.getSeatsHtml(_this.getSeatsStatusForTable($(this).data('dbid')), capacity);

                    $(this).find(".square").css({"width":size,"height":size,"line-height":(size-2)+"px"});
                    for (let i = 0; i < 4; i++) {
                        text += "<div class='tableSide side"+i+"'>";
                        if(sides[`side${i}`] && sides[`side${i}`] !== ''){
                            capacityPerSide = sides[`side${i}`];
                        }

                        for (let j = 0; j < capacityPerSide; j++) {
                            let seat = seats.shift();
                            if(typeof seat !=='undefined') text += seat;
                        }

                        //if left any un splitable seats
                        if(i === 4 && seats.length > 0){
                            text += seats.join("");
                        }
                        text += "</div>";
                    }
                    $(this).find(".square").append(text);
                });

                $(".circleTable").each(function() {
                    let capacity  = $(this).data("capacity"),
                        size = capacity * 3,
                        text = "",
                        rot = 0,
                        angle = 360/capacity,
                        angleV = 85,
                        occupiedPlaces  = $(this).data("occupiedplaces");

                    let seats = _this.getSeatsHtml(_this.getSeatsStatusForTable($(this).data('dbid')), capacity);

                    $(this).find(".circle").css({"width":size,"height":size,"line-height":(size-2)+"px"});
                    for (let i = 0; i < capacity; i++) {
                        let translateV=capacity*2,
                            rotateV = rot * 1;

                        let seat = seats.shift();
                        if(typeof seat !=='undefined'){
                            seat = $(seat).attr('style',"transform: rotate("+rotateV+"deg) translate("+translateV+"px) rotate("+angleV+"deg)")[0].outerHTML;
                            text += seat;

                            rot= rot + angle;
                            angleV = angleV + 1;
                        }

                    }
                    $(this).find(".circle").append(text);

                });
                $(".rectangleTable").each(function() {

                    let capacity  = $(this).data("capacity"),
                        tablehead  = $(this).data("tablehead"),
                        capacityPerSideHeight = (capacity - (tablehead*2))/2,
                        capacityPerSideWidth = tablehead,
                        width = capacityPerSideWidth * 14,
                        height = capacityPerSideHeight * 14,
                        text = "";

                    let sides = {};
                    if(typeof $(this).data('side1') !== 'undefined') {
                        sides = {
                            side0: (typeof $(this).data('side1') !== 'undefined' && $(this).data('side1') != '' ? $(this).data('side1') : ''),
                            side1: (typeof $(this).data('side2') !== 'undefined' && $(this).data('side2') != '' ? $(this).data('side2') : ''),
                            side2: (typeof $(this).data('side3') !== 'undefined' && $(this).data('side3') != '' ? $(this).data('side3') : ''),
                            side3: (typeof $(this).data('side4') !== 'undefined' && $(this).data('side4') != '' ? $(this).data('side4') : ''),
                        };
                    }else {
                        sides = {
                            side0: (typeof $(this).parent().data('side1') !== 'undefined' && $(this).parent().data('side1') != '' ? $(this).parent().data('side1') : ''),
                            side1: (typeof $(this).parent().data('side2') !== 'undefined' && $(this).parent().data('side2') != '' ? $(this).parent().data('side2') : ''),
                            side2: (typeof $(this).parent().data('side3') !== 'undefined' && $(this).parent().data('side3') != '' ? $(this).parent().data('side3') : ''),
                            side3: (typeof $(this).parent().data('side4') !== 'undefined' && $(this).parent().data('side4') != '' ? $(this).parent().data('side4') : ''),
                        };
                    }

                    let seats = _this.getSeatsHtml(_this.getSeatsStatusForTable($(this).data('dbid')), capacity);

                    if(sides.hasOwnProperty('side1') && sides.side1 !=='') width = sides.side1 * 16

                    $(this).find(".rectangle").css({"width":width,"height":height,"line-height":(height-2)+"px"});
                    for (let i = 0; i < 4; i++) {
                        text += "<div class='tableSide side"+i+"'>";

                        if(i == 1 || i==3){

                            if(sides.hasOwnProperty(`side${i}`) && sides[`side${i}`] && sides[`side${i}`] != ''){
                                capacityPerSideWidth = sides[`side${i}`];
                            }
                            for (let j = 0; j < capacityPerSideWidth; j++) {
                                let seat = seats.shift();
                                if(typeof seat !=='undefined') text += seat;
                            }
                        }else{
                            if(sides.hasOwnProperty(`side${i}`) && sides[`side${i}`] && sides[`side${i}`] != '') {
                                capacityPerSideHeight = sides[`side${i}`];
                            }
                            for (let j = 0; j < capacityPerSideHeight; j++) {
                                let seat = seats.shift();
                                if(typeof seat !=='undefined') text += seat;
                            }
                        }

                        text += "</div>";
                    }
                    $(this).find(".rectangle").append(text);
                });


                //each item events
                $('body .item').each(function(){

                    //mark
                    $(this).off('click')
                        .on('click',function(){
                            let dbID = $(this).find('[data-dbid]').data('dbid')

                            if(_this.tablesNumbering || _this.tablesReserving){
                                _this.event.presetData.some((item) => {
                                    if (item.type =="table" && item.dbID === dbID) {
                                        if(_this.tablesNumbering) {
                                            _this.recursiveTableNumbering(_this.autoNumStart, dbID);
                                            item.tableNum = _this.autoNumStart;
                                            _this.autoNumStart++;
                                            $(`[data-dbid="${item.dbID}"]`).find('.tableNum').text(item.tableNum);
                                            return true;
                                        } else {
                                            item.reserved = !(item.hasOwnProperty("reserved") && item.reserved === true) ;
                                            $(`[data-dbid="${item.dbID}"]`).find('.tableNum').text(item.reserved ? _this.$t('reserved') : item.tableNum);
                                        }
                                    }
                                });

                               _this.save();
                            }else {
                                if (!_this.selectMode && _this.selected.length == 0) _this.selectMode = true;
                                if (_this.selectMode) {
                                    if (!_this.selected.includes(dbID)) {
                                        _this.selected.push(dbID)
                                    } else {
                                        _this.selected = _this.selected.filter(e => e !== dbID);
                                    }
                                    _this.selectModeMark();
                                }
                            }
                        });

                    //resize & rotate
                    $(this).off('mouseenter mouseleave')
                        .on('mouseenter',function(){
                            $(this).addClass('hovered');
                        })
                        .on('mouseleave',function(){
                            $(this).removeClass('hovered');
                        })
                    ;
                });

                $('.deleteIcon').off('click').on('click',function(e){
                    e.preventDefault();
                    let dbID = $(this).parents('span').find('[data-dbid]:first').data('dbid');

                    if(typeof dbID !=='undefined' && dbID != ''){
                        _this.$swal({
                            title: _this.$t('removeItemPrompt'),
                            text: _this.$t('unrevetableOperation'),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#d33',
                            cancelButtonColor: '#3085d6',
                            confirmButtonText: _this.$t('yes'),
                            cancelButtonText: _this.$t('no')
                        }).then((result) => {

                            if (result === true) {
                                _this.event.presetData = _this.event.presetData.filter((_)=>{
                                    if(_.dbID == dbID) return false;
                                    return true;
                                });
                                _this.save();
                            }
                        })
                            .catch(()=>{
                                /*do nothing*/
                            });
                    }

                    return false;
                });

                $('.editIcon').off('click').on('click',function(e){
                    e.preventDefault();
                    let dbID = $(this).parents('span').find('[data-dbid]:first').data('dbid');
                    let quantity = $(this).parents('span').find('[data-capacity]:first').data('capacity');

                    if(typeof dbID !=='undefined' && dbID != ''){
                        _this.$swal({
                            title: _this.$t('startNumberTitle'),
                            text: _this.$t('capacityChangeText'),
                            input: 'text',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            inputValue:quantity,
                            showLoaderOnConfirm:true,
                            confirmButtonText: _this.$t('save'),
                            cancelButtonText: _this.$t('cancel'),
                            preConfirm: function(value) {
                                return new Promise(function(resolve) {
                                    if (typeof value ==='undefined' || value == '') {
                                        _this.$swal.showValidationError(
                                            _this.$t('capacityRequired')
                                        )
                                        _this.$swal.hideLoading();
                                    }else {
                                        resolve()
                                    }
                                });
                            },
                        }).then((num) => {
                            num = parseInt(num);
                            if(isNaN(num)) return;
                            _this.event.presetData.filter((item) => {
                                if (item.type == 'table' && item.dbID === dbID) {
                                    item.tableCapcity = num;
                                }
                            })
                            _this.save()
                        }).catch(_this.$swal.noop);
                    }

                    return false;
                });

                //resize
                $('.item').resizable('destroy');
                $('.item')
                    .resizable({
                        handleSelector: "> .resizeIcon",
                        scaleResizing:true,
                        onDragEnd: function (e, $el, opt) {
                            let dbID = $el.find('[data-dbid]:first').data('dbid')
                            _this.event.presetData.forEach((elm)=>{
                                if(elm.dbID == dbID){
                                    elm.scale = $el.data('scale')
                                }
                            })
                            _this.save()
                        }
                    });

                //rotate
                $('.item')
                    .resizable({
                        handleSelector: "> .rotateIcon",
                        rotation:true,
                        onDragEnd: function (e, $el, opt) {
                            let dbID = $el.find('[data-dbid]:first').data('dbid')
                            _this.event.presetData.forEach((elm)=>{
                                if(elm.dbID == dbID){
                                    elm.rotation = $el.data('rotation')
                                }
                            })
                            _this.save()
                        }
                    });

                if(this.selectMode) this.selectModeMark()

                if(this.getTotalGuests() >= 1) Pizza.init();
                this.fixRectangleHeight();
            },
            recursiveTableNumbering(num, dbID){
                for (const item of this.event.presetData) {
                    if(item.dbID !== dbID && item.tableNum && !isNaN(parseInt(item.tableNum)) && parseInt(item.tableNum) === num){
                        item.tableNum = parseInt(item.tableNum)+1;
                        $(`[data-dbid="${item.dbID}"]`).find('.tableNum').text(item.tableNum);
                        this.recursiveTableNumbering(item.tableNum,item.dbID);
                        break;
                    }
                }

            },
            selectModeMark(){
                $('.item').removeClass('selected')
                this.selected.forEach((id)=>{
                    $('[data-dbid="'+id+'"]').parent().addClass('selected')
                })
                if(this.selected.length ==0) this.selectMode = false;
            },

            initJS(){
                let _this = this;
                let layout={
                    elements: (!this.event.presetData.length ? [] : this.event.presetData)
                };

                $('#gridWrap').html('');
                _this.setLayout(layout);

                $( "body" ).on( "change", "#ulamType", function() {
                    let placesNumber = $(this).find(':selected').data('places');
                    $(".ulamCapacity").text(placesNumber);
                });
                let container = document.getElementById("dragablleItems");

                try{
                    window.sort.destroy();
                    window.sort2.destroy();
                    window.sort3.destroy();
                }catch(e){
                    //i dont care!
                }

                window.sort = Sortable.create(container, {
                    group:{name:'dict',pull:'clone',put:false},
                    sort: false,  // sorting inside list
                    delay: 0,
                    draggable: ".item",
                    onEnd: function (/**Event*/evt) {
                        let itemEl = evt.item;  // dragged HTMLElement

                        let x = event.pageX - $("#gridWrap").offset().left-20;
                        let y = event.pageY - $("#gridWrap").offset().top-20;

                        // x = ((x/$("#gridWrap").width())*100)
                        // y = ((y/$("#gridWrap").height())*100)

                        //calculare percentage

                        $(itemEl).css({"top":y+'px',"left":x+'px'});
                        _this.saveChanges();
                    },
                    onMove: function (/**Event*/evt, /**Event*/originalEvent) {
                        let itemPos = originalEvent.clientY;
                    },


                });
                let container_2 = document.getElementById("dragablleItems_2");
                window.sort2 = Sortable.create(container_2, {
                    group:{name:'dict',pull:'clone',put:false},
                    sort: false,  // sorting inside list
                    delay: 0,
                    draggable: ".item",
                    onEnd: function (/**Event*/evt) {
                        let itemEl = evt.item;  // dragged HTMLElement
                        let x = event.pageX - $("#gridWrap").offset().left-20;
                        let y = event.pageY - $("#gridWrap").offset().top-20;

                        // x = ((x/$("#gridWrap").width())*100)
                        // y = ((y/$("#gridWrap").height())*100)

                        $(itemEl).css({"top":y+'px',"left":x+'px'});
                        _this.saveChanges();
                    },
                    onMove: function (/**Event*/evt, /**Event*/originalEvent) {
                        let itemPos = originalEvent.clientY;
                    },


                });
                let container2 = document.getElementById("gridWrap");
                window.sort3 = Sortable.create(container2, {
                    group:{name:'dict',pull:true,put:true},
                    sort: false,
                    draggable: ".item",
                    onStart: function(evt){
                        let itemEl = evt.item;  // dragged HTMLElement
                        let scale = $(itemEl).data('scale');

                        let x=0,y=0;
                        if(scale > 1 || scale < 1) {

                            let elHeight = $(itemEl).height(),
                                elWidth = $(itemEl).width();

                            let newElHeight = elHeight*scale,
                                newElWidth = elWidth*scale;

                            let left = Math.abs((newElWidth-elWidth)/2),
                                top = Math.abs((newElHeight-elHeight)/2);

                            x = evt.pageX - $("#gridWrap").offset().left-20+left;
                            y = evt.pageY - $("#gridWrap").offset().top-20+top;

                        }else{
                            x = evt.pageX - $("#gridWrap").offset().left-20;
                            y = evt.pageY - $("#gridWrap").offset().top-20;
                        }


                        // x = ((x/$("#gridWrap").width())*100)
                        // y = ((y/$("#gridWrap").height())*100)
                        $(itemEl).css({"top": y+'px', "left": x+'px'});

                        //grid layout
                        let leftPositionInParent = $(itemEl).offset().left - $('#gridWrap').offset().left;
                        let topPositionInParent = $(itemEl).offset().top - $('#gridWrap').offset().top;

                        _this.draggedItem = {
                            dbID: $(itemEl).find('data-dbid').data('dbid'),
                            startPosition:{left:leftPositionInParent,top:topPositionInParent}
                        }

                    },
                    onEnd: function (/**Event*/evt) {
                        let itemEl = evt.item;  // dragged HTMLElement
                        let scale = $(itemEl).data('scale');
                        let x=0,y=0;
                        if(scale > 1 || scale < 1) {

                            let elHeight = $(itemEl).height(),
                                elWidth = $(itemEl).width();

                            let newElHeight = elHeight*scale,
                                newElWidth = elWidth*scale;

                            let left = Math.abs((newElWidth-elWidth)/2),
                                top = Math.abs((newElHeight-elHeight)/2);

                            x = event.pageX - $("#gridWrap").offset().left-20+left;
                            y = event.pageY - $("#gridWrap").offset().top-20+top;

                        }else{
                            x = event.pageX - $("#gridWrap").offset().left-20;
                            y = event.pageY - $("#gridWrap").offset().top-20;
                        }


                        // x = ((x/$("#gridWrap").width())*100)
                        // y = ((y/$("#gridWrap").height())*100)
                        $(itemEl).css({"top": y+'px', "left": x+'px'});

                        //grid layout
                        let leftPositionInParent = $(itemEl).offset().left - $('#gridWrap').offset().left;
                        let topPositionInParent = $(itemEl).offset().top - $('#gridWrap').offset().top;
                        if(_this.inGridMode){

                            $(itemEl).css({"top": _this.closestStep(topPositionInParent,'height',$(itemEl).width()) + 'px', "left": _this.closestStep(leftPositionInParent,'width',$(itemEl).width()) + 'px'});
                        }

                        if(_this.selectMode && _this.selected.length > 1){
                            //get diff
                            let left = leftPositionInParent - _this.draggedItem.startPosition.left
                            let top = topPositionInParent - _this.draggedItem.startPosition.top

                            _this.selected.forEach((_)=>{
                                if(_ != $(itemEl).find('[data-dbid]').data('dbid')){
                                    let tbl = $('[data-dbid="'+_+'"]').parent();
                                    let newPosition = {
                                        left:parseInt(tbl.css('left').toString().replace(/[^\d|.]/g,'')) + left,
                                        top:parseInt(tbl.css('top').toString().replace(/[^\d|.]/g,'')) + top,
                                    }
                                    tbl.css('left',newPosition.left+'px')
                                    tbl.css('top',newPosition.top+'px')
                                }
                            })
                        }

                        _this.saveChanges();
                    },
                });

                $(".matchHeight").matchHeight();


                $('#gridWrap').off('click').on('click',function(e){
                    if((!$(e.target).parents('.item').length || (_this.selected.length != 1 && $(e.target).parents('.item').length)) && !_this.controlPressed && !_this.tablesNumbering){
                        _this.selectMode = false;
                        _this.selected = [];
                        _this.selectModeMark();
                    }
                });

            },
            closestStep(position,type = 'width', elmWidth){

                let gridDimensions = {
                    width:parseInt(($('#gridWrap').width())/12),
                    height:parseInt(($('#gridWrap').height())/12),
                };
                let gridSteps = [];

                for(let step = 0;step<=gridDimensions[ type ]*12;step+=gridDimensions[ type ]){
                    gridSteps.push(step)
                }
                gridSteps.shift();
                gridSteps.pop();

                let i=0;
                let minDiff=1000;
                let ans;
                for(i in gridSteps){
                    let m=Math.abs(position-gridSteps[i]);
                    if(m<minDiff){
                        minDiff=m;
                        ans=gridSteps[i];
                    }
                }

                ans -= elmWidth/2;

                /*//calculate to percent
                if(type == "height"){
                    ans = ((ans/$("#gridWrap").height())*100)
                }else{
                    ans = ((ans/$("#gridWrap").width())*100)
                }*/

                return ans;
            },
            setPreset(){
                let _this = this;
                if(this.event.preset.id > 0){
                    this.$swal({
                        title: this.$t('changePresetPrompt'),
                        text: this.$t('unrevetableOperation'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#d33',
                        cancelButtonColor: '#3085d6',
                        confirmButtonText: this.$t('yes'),
                        cancelButtonText: this.$t('no')
                    }).then((result) => {

                        if (result === true) {
                            if(this.selectedPreset != ''){
                                for(let preset of this.presets){
                                    if(preset.id == this.selectedPreset){
                                        this.event.preset = preset;
                                        this.event.presetData = preset.jData;
                                        break;
                                    }
                                }
                            }
                            //save preset on bg
                            this.updatePreset();
                        }else{
                            _this.selectedPreset = _this.event.preset.id
                        }
                    })
                        .catch(()=>{
                            _this.selectedPreset = _this.event.preset.id
                        });
                }else{
                    if(this.selectedPreset != ''){
                        for(let preset of this.presets){
                            if(preset.id == this.selectedPreset){
                                this.event.preset = preset;
                                this.event.presetData = preset.jData;
                                break;
                            }
                        }
                    }
                    this.updatePreset();
                }
            },
            updatePreset(){
                let presetCleaned = this.event.preset.jData;
                if(presetCleaned.length){
                    presetCleaned.forEach(function(item){
                        if(item.type =='table') item.occupiedPlaces = '0';
                    });
                }
                this.$store.dispatch('updateEvent',{'id':this.event.id,'preset':this.selectedPreset,'presetData':presetCleaned})
                    .then((_)=>{
                        this.setLayout({elements:presetCleaned})
                    })
                    .catch(err => {
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('fatalError'),
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
            },
            setPresetLock(){
                this.event.presetLocked = $('#lockPresetCheckBox').is(':checked');
                this.$store.dispatch('updateEvent',{'id':this.event.id,'presetLocked':this.event.presetLocked})
                    .catch(err => {
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('fatalError'),
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
            },

            setStrictTables(){
                this.event.strictTables = $('#strictTablesCheckbox').is(':checked');
                this.$store.dispatch('updateEvent',{'id':this.event.id,'strictTables':this.event.strictTables})
                    .catch(err => {
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('fatalError'),
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
            },

            setAllowReservedSeating(){
                this.event.resevedSeatingAllowed = $('#resevedSeatingAllowedCheckbox').is(':checked');
                this.$store.dispatch('updateEvent',{'id':this.event.id,'resevedSeatingAllowed':this.event.resevedSeatingAllowed})
                    .catch(err => {
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('fatalError'),
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
            },
            saveChanges(){
                let items = [];
                const _this = this;
                let $container = $("#gridWrap");
                const gridWidth = $container.width();
                const gridHeight = $container.height();

                $container.find('.item').each(function(){

                    let $realEl = $(this).find('div').first();

                    let dbID = $realEl.data('dbid');
                    if(typeof dbID ==='undefined' || !dbID || dbID == ''){
                        dbID = window.guid();
                    }

                    let item = {
                        "dbID":dbID,
                        "id":$(this).index(),
                        "shape":$realEl.data('shape'),
                        "type":$realEl.data('type'),
                        "reserved":$realEl.data('reserved') === true,
                        "scale":$realEl.parent().data('scale'),
                        "rotation":$realEl.parent().data('rotation'),
                        "position":{
                            /*"x":$(this).css('left').toString().replace(/[^\d|.]/g,''),
                            "y":$(this).css('top').toString().replace(/[^\d|.]/g,'')*/
                            "x":$(this)[0].style.left,
                            "y":$(this)[0].style.top
                        }
                    };

                    try{
                        let x = item.position.x.replace("px","");
                        let y = item.position.y.replace("px","");

                        if(x < 0 || y < 0 || x > $("#gridWrap").width() || y > gridHeight) {
                            item.position.x = "0px";
                            item.position.y = "40px";
                        }

                    } catch (e){

                    }

                    if(typeof $realEl.data('side1') !== 'undefined') {
                        Object.assign(item,{
                            side1: (typeof $realEl.data('side1') !== 'undefined' && $realEl.data('side1') != '' ? $realEl.data('side1') : ''),
                            side2: (typeof $realEl.data('side2') !== 'undefined' && $realEl.data('side2') != '' ? $realEl.data('side2') : ''),
                            side3: (typeof $realEl.data('side3') !== 'undefined' && $realEl.data('side3') != '' ? $realEl.data('side3') : ''),
                            side4: (typeof $realEl.data('side4') !== 'undefined' && $realEl.data('side4') != '' ? $realEl.data('side4') : ''),
                        });
                    }else {
                        Object.assign(item,{
                            side1: (typeof $realEl.parent().data('side1') !== 'undefined' && $realEl.parent().data('side1') != '' ? $realEl.parent().data('side1') : ''),
                            side2: (typeof $realEl.parent().data('side2') !== 'undefined' && $realEl.parent().data('side2') != '' ? $realEl.parent().data('side2') : ''),
                            side3: (typeof $realEl.parent().data('side3') !== 'undefined' && $realEl.parent().data('side3') != '' ? $realEl.parent().data('side3') : ''),
                            side4: (typeof $realEl.parent().data('side4') !== 'undefined' && $realEl.parent().data('side4') != '' ? $realEl.parent().data('side4') : ''),
                        });
                    }

                    if(typeof $(this).find('.itemLabel') !=='undefined' && $(this).find('.itemLabel').length > 0){
                        item.text = $(this).find('.itemLabel').text();
                    }

                    if(item.type == 'table'){
                        Object.assign(item,{
                            "tableNum":$realEl.find('.tableNum').text(),
                            "tableCapcity":$realEl.data('capacity'),
                            "occupiedPlaces":$realEl.data('occupiedplaces')
                        });
                    }else{
                        item.shape = '';
                    }

                    if(item.hasOwnProperty("tableNum") && item.tableNum === _this.$t('reserved')) item.tableNum = "";

                    if(item.shape === "") item.shape = $realEl.data('shape');
                    if(item.shape !=="") items.push(item);
                });
                this.event.presetData = items;

                this.save()
            },
            save(isRestore = false){
                this.$store.dispatch('updateEvent',{'id':this.event.id,'presetData':this.event.presetData,'resetPreset':this.event.hasOwnProperty("resetPreset") && this.event.resetPreset === true})
                    .then((_)=>{
                        this.event.resetPreset = false;
                        this.setLayout({elements:this.event.presetData},isRestore)
                    })
                    .catch(err => {

                        this.event.resetPreset = false;

                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('fatalError'),
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
                this.fixRectangleHeight()
            },
            fixRectangleHeight(){
                $('.side3').each(function(){
                    $(this).css({'top':0-$(this).parent().height()-2,'height':20})
                })
            },
            copyItems(){
                if(this.selectMode) {
                    let _this = this;
                    let toCopy = this.event.presetData.filter((item) => {
                        if (this.selected.includes(item.dbID)) return true;
                        return false;
                    })
                    if(toCopy.length > 0) {
                        const items = [];
                        for(let i in toCopy){
                            let item = toCopy[i];
                            let newItem = {};
                            Object.assign(newItem,item)
                            newItem.dbID = window.guid();
                            newItem.id = parseInt(_this.event.presetData.length) + parseInt(i) + 1;
                            newItem.tableNum = '';
                            newItem.position = {
                                x:(parseInt(newItem.position.x.toString().replace(/[^\d|.]/g,''))+5)+'px',
                                y:(parseInt(newItem.position.y.toString().replace(/[^\d|.]/g,'')))+'px'
                            };
                            items.push(newItem.dbID);
                            _this.event.presetData.push(newItem);
                        }
                       _this.save()
                        _this.selected = items;
                    }
                } else {
                    this.$swal({
                        confirmButtonText:this.$t('okButton'),
                        type:'error',
                        title:this.$t('firstUseSelectMode'),
                        timer:3000
                    }).catch(this.$swal.noop);
                }
            },
            autoNum(){
                this.tablesNumbering = false;
                this.tablesReserving = false;
                let _this = this;
                this.$swal({
                               title: this.$t('startNumberTitle'),
                               text: this.$t('startNumberText'),
                               input: 'text',
                               showCancelButton: true,
                               confirmButtonColor: '#3085d6',
                               cancelButtonColor: '#d33',
                               inputValue:1,
                               showLoaderOnConfirm:true,
                               confirmButtonText: this.$t('save'),
                               cancelButtonText: this.$t('cancel'),
                               preConfirm: function(value) {
                                   return new Promise(function(resolve) {
                                       if (typeof value ==='undefined' || value == '') {
                                           _this.$swal.showValidationError(
                                               _this.$t('startNumberRequired')
                                           )
                                           _this.$swal.hideLoading();
                                       }else {
                                           resolve()
                                       }
                                   });
                               },
                           }).then((num) => {
                    num = parseInt(num);
                    if(isNaN(num)) return;
                    this.autoNumStart = num;
                    this.tablesNumbering = true
                }).catch((res) => {
                    this.tablesNumbering = false
                });
            },
            setTablesReserving(){
                this.tablesNumbering = false;
                this.tablesReserving = !this.tablesReserving;
            },
            getSeats(fetch = 'all'){
                let seats = 0;
                let taken = 0;
                const _this = this;
                let available = 0;
                try {
                    this.event.presetData.forEach((item) => {
                        if (item.type == 'table') {
                            if(!item.hasOwnProperty("reserved") || item.reserved !== true || _this.event.resevedSeatingAllowed === true) {
                                if (!isNaN(item.tableCapcity)) seats += parseInt(item.tableCapcity);
                                if (this.event.guests.length > 0) {
                                    for (let guest of this.event.guests) {
                                        if (guest.tableID == item.dbID && typeof guest.status
                                            === 'object') {
                                            taken += parseInt(guest.quantity);
                                        }
                                    }
                                }
                            }
                        }
                    })
                }catch(e){
                    // i dont care!
                }

                switch(fetch){
                    case 'all':
                    default:
                        return seats;
                        break;

                    case 'taken':
                        return taken;
                        break;

                    case 'available':
                        return ((seats-taken) > 0 ? (seats-taken) : 0);
                        break;
                }
            },
            getShape(shape){
                switch(shape){
                    case 'squareTable':
                    case 'wood':
                        return 'square';
                        break;

                    case 'circleTable':
                        return 'circle';
                        break;

                    case 'rectangleTable':
                        return 'rectangle';
                        break;

                    case 'ellipseTable':
                        return 'ellipse';
                        break;

                    case 'drop':
                        return 'drop';
                        break;

                    default: return 'square'; break;
                }
            },
            useGrid(){
                this.inGridMode = !this.inGridMode;
                this.$store.dispatch('updateEvent',{id:this.event.id,inGridMode:this.inGridMode})
            },
            useGroupSeating(){
                this.event.groupSeating = !this.event.groupSeating;
                this.$store.dispatch('updateEvent',{id:this.event.id,groupSeating:this.event.groupSeating})
            },
            resetPreset(){
                this.$swal({
                    title: this.$t('resetPresetPrompt'),
                    text: this.$t('unrevetableOperation'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                }).then((result) => {

                    if (result === true) {
                        this.confirmReset();
                    }
                }).catch(this.$swal.noop);
            },
            confirmReset(){
                let _this = this;
                this.$swal({
                    title: this.$t('beforeWeReset'),
                    text: this.$t('enterYourPassword'),
                    input: 'password',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    showLoaderOnConfirm:true,
                    confirmButtonText: this.$t('resetPreset'),
                    cancelButtonText: this.$t('cancel'),
                    preConfirm: function(value) {
                        return new Promise(function(resolve) {
                            if (typeof value ==='undefined' || value == '') {
                                _this.$swal.showValidationError(
                                    _this.$t('presetNameRequired')
                                )
                                _this.$swal.hideLoading();
                            }else {

                                //validate
                                _this.$store.dispatch('checkPassword',value)
                                    .then(response =>{
                                        //success
                                        resolve()
                                    })
                                    .catch(err => {
                                        //err
                                        _this.$swal({
                                            confirmButtonText: _this.$t('okButton'),
                                            type: 'error',
                                            title: _this.$t('passwordIncorrect'),
                                            timer: 3000
                                        })
                                    })

                            }
                        });
                    },
                }).then((password) => {

                    this.event.presetData = [];
                    this.event.resetPreset = true;
                    this.save();
                }).catch(this.$swal.noop);
            },
            saveAsTemplate(){
                let _this = this;
                this.$swal({
                    title: this.$t('saveAsTemplateTitle'),
                    text: this.$t('saveAsTemplateText'),
                    input: 'text',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    showLoaderOnConfirm:true,
                    confirmButtonText: this.$t('save'),
                    cancelButtonText: this.$t('cancel'),
                    preConfirm: function(value) {
                        return new Promise(function(resolve) {
                            if (typeof value ==='undefined' || value == '') {
                                _this.$swal.showValidationError(
                                    _this.$t('presetNameRequired')
                                )
                                _this.$swal.hideLoading();
                            }else {
                                resolve()
                            }
                        });
                    },
                }).then((presetName) => {
                    let presetCleaned = this.event.presetData;
                    if(presetCleaned.length){
                        presetCleaned.forEach(function(item){
                            if(item.type =='table') item.occupiedPlaces = '0';
                        });
                    }
                    this.$store.dispatch('addPreset',{'name':presetName,'jData':presetCleaned,'hall':this.event.hall.id,'background':window.basename(this.event.preset.background),'capacity':this.event.preset.capacity})
                        .then(response =>{
                            //success
                            this.$swal({
                                confirmButtonText:this.$t('okButton'),
                                type:'success',
                                title:this.$t('presetAdded'),
                                timer:2000
                            }).catch(this.$swal.noop);
                            this.$store.dispatch('getPreset','hall/' + this.event.hall.id)
                                .then(response =>{
                                    //success
                                    this.presets = response;
                                })
                        })
                        .catch(err => {
                            //err
                            this.$swal({
                                confirmButtonText:this.$t('okButton'),
                                type:'error',
                                title:this.$t('fatalError'),
                                timer:3000
                            }).catch(this.$swal.noop);
                        })
                }).catch(this.$swal.noop);
            },
            finishSelectMode(){
                this.selectMode = false;
                this.selected = [];
                $('.item').removeClass('selected')
            },
            initRollbackEngine(){
                sessionStorage.clear();
                let _this = this;
                $(document).ready(function(){
                    $(document).off('keydown').on('keydown',function(e){
                        if( e.which === 90 && e.ctrlKey && e.shiftKey ){
                            _this.restoreVersion('redo')
                        }
                        else if( e.which === 90 && e.ctrlKey ){
                            _this.restoreVersion('undo')
                        }
                    });
                });
            },
            saveRollBack(layout = {}){
                let versions = Object.keys(sessionStorage).filter((_)=>{
                    return (_.includes('version_'));
                });
                versions.sort();
                let ver = 'version_' + ((versions.length ? versions.length : 0)+1);
                sessionStorage.setItem(ver,JSON.stringify(layout))
                sessionStorage.setItem('currentVersion',(versions.length+1))
            },
            restoreVersion(opr = 'undo'){
                let version = {};
                let current = parseInt(sessionStorage.getItem('currentVersion'));
                let versionToGo = 0;

                let versions = Object.keys(sessionStorage).filter((_)=>{
                    return (_.includes('version_'));
                });
                versions.sort();

                if(current == 1 && versions.length == 1) return

                if(versions.length > 0){
                    switch(opr){
                        case 'undo':
                        case 'undo':
                            if(typeof sessionStorage.getItem('version_' + (current - 1)) !=='undefined')
                                versionToGo = current - 1;
                            break;

                        case 'redo':
                            if(typeof sessionStorage.getItem('version_' + (current + 1)) !=='undefined')
                                versionToGo = current+1;
                            break;
                    }
                }

                if(versionToGo < 1) versionToGo = 1;
                if(versionToGo > versions.length) versionToGo = versions.length

                if(typeof versionToGo ==='undefined' || current == versionToGo) return;

                version = sessionStorage.getItem('version_' + versionToGo);
                sessionStorage.setItem('currentVersion',versionToGo);
                try{
                    version = JSON.parse(version);
                    this.event.presetData = version.elements;
                    this.save(true)
                }catch(e){
                    console.warn('failed to restore with error - ' + e.toString())
                }

            },
            async savePresetScreenShot(){
                this.savingPresetScreenshot = true;
                const params = {
                    backgroundColor: null,
                    async: true,
                    logging: false,
                    useCORS: true,
                    imageTimeout: 15000,
                    windowWidth: 1920,
                    windowHeight: 1080
                };
                const canvas = await html2canvas(document.getElementById('gridWrap'),params);
                const b64Image = canvas.toDataURL();
                this.$store.dispatch('uploadFile',{base_64:true,eventID:this.event.id,screenshot:b64Image})
                    .then(res=>{
                        this.savingPresetScreenshot = false;
                        this.$store.state.selectedEventID = this.event.id;
                        this.$swal({
                                        confirmButtonText:this.$t('okButton'),
                                        type:'success',
                                        title:this.$t('screenShotSaved'),
                                        timer:3000
                                    }).catch(this.$swal.noop);
                    })
                    .catch(err => {
                        //err
                        this.savingPresetScreenshot = false;
                        console.warn('failed to save screenshot - ' + err.toString())
                    })
            },
            initKeyboardMovements(){
                let _this = this;
                $('body').off('keyup').on('keyup',function(e) {
                    let map = {
                        37:'left',
                        38:'up',
                        39:'right',
                        40:'down',
                        17:'control',
                        46:'delete',
                    }


                    if(map.hasOwnProperty(e.keyCode) && map[e.keyCode] == "control"){
                        _this.controlPressed = false
                    }

                    if(_this.selectMode && map.hasOwnProperty(e.keyCode)) {
                        setTimeout(function () {
                            if (_this.$store.state.lastInteraction < (Math.floor(Date.now() / 1000))) {
                                _this.saveChanges();
                            }
                        }, 1000);
                    }
                });
                $('body').off('keydown').on('keydown',function(e){
                    let map = {
                        37:'left',
                        38:'up',
                        39:'right',
                        40:'down',
                        17:'control',
                        46:'delete',
                    }

                    if(map.hasOwnProperty(e.keyCode) && map[e.keyCode] == "control"){
                        _this.controlPressed = true
                    }

                    if(_this.selectMode && map.hasOwnProperty(e.keyCode)){
                        e.preventDefault();

                        _this.$store.state.lastInteraction = (Math.floor(Date.now() / 1000));

                        _this.selected.forEach((_item)=>{
                            let item = $('[data-dbid="'+_item+'"]').parent();
                            let position = {
                                left:parseInt(item.css('left').toString().replace(/[^\d|.]/g,'')),
                                top:parseInt(item.css('top').toString().replace(/[^\d|.]/g,''))
                            }
                            switch(map[e.keyCode]){
                                case 'left':
                                    position.left--;
                                    break;
                                case 'right':
                                    position.left++;
                                    break;
                                case 'up':
                                    position.top--;
                                    break;
                                case 'down':
                                    position.top++;
                                    break;
                            }

                            item.css('left',position.left+'px')
                            item.css('top',position.top+'px')

                        })

                    }

                    if(_this.selectMode && map.hasOwnProperty(e.keyCode) && map[e.keyCode] === "delete"){
                        _this.selected.forEach((_item)=> {
                            let item = $('[data-dbid="' + _item + '"]').parent();
                            item.remove();
                        });
                    }
                })
            },
            _destroy(){
                sessionStorage.clear();
                try{
                    window.sort.destroy();
                    window.sort2.destroy();
                    window.sort3.destroy();
                }catch(e){
                    //i dont care!
                }
            }
        },
        beforeDestroy(){
            this._destroy()
        },
        destroyed(){
            this._destroy()
        }
    }

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

    .eventPresetView h2{
        color:#7893c1;
        font-size: 1.706rem;
        font-weight: 700;
    }
    .eventPresetView h3{
        color: #293b5a;
        font-weight: 700;
        font-size:1.059rem;
    }
    .eventPresetView.innerMainContent{
        padding:55px 45px;
        float: right;
        width:100%;
    }

    .eventPresetView .editEventActions{
        float:left;
        margin-top: 6px;
    }



    .eventPresetView .deleteEvent{
        width: 181px;
        height: 42px;
        border: 1px solid #52dbcd;
        border-radius: 21px;
        background: -moz-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ff3.6+ */
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41, 59, 90, 1)), color-stop(100%, rgba(123, 150, 196, 1)));
        /* safari4+,chrome */
        background: -webkit-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* safari5.1+,chrome10+ */
        background: -o-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* opera 11.10+ */
        background: -ms-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ie10+ */
        background: linear-gradient(90deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* w3c */
        filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4', GradientType=1 );
        /* ie6-9 */
    }
    .eventPresetView .deleteEvent svg{
        display: inline-block;
        vertical-align: middle;
        width: 13px;
        height: 17px;
        fill: #fff;
        margin-left: 10px;
    }
    .eventPresetView .deleteEvent span{
        display: inline-block;
        vertical-align: middle;
        margin-top: -2px;
        font-size: 0.8235rem;
        font-weight: 700;
        color:#fff;
    }
    .eventPresetView .noteEvent{
        width: 181px;
        height: 42px;
        border: 1px solid #bdbdbd;
        border-radius: 21px;
        margin-left: 15px;
    }
    .eventPresetView .noteEvent svg{
        display: inline-block;
        vertical-align: middle;
        width: 22px;
        height: 17px;
        fill: #364764;
        margin-left: 10px;
    }
    .eventPresetView .noteEvent span{
        display: inline-block;
        vertical-align: middle;
        margin-top: -2px;
        font-size: 0.8235rem;
        font-weight: 700;
        color:#7792bf;
    }
    .eventPresetView .pieWrapper .pieInnerWrapper{
        width:50%;
        float: right;
    }

    .eventPresetView .pieWrapper #pie-svg{
        width:50%;
        float: right;
    }

    [data-pie-id] > *:nth-child(7n+1), [data-bar-id] > *:nth-child(7n+1), [data-line-id] > *:nth-child(7n+1) {
        color: #293b5a; }
    [data-pie-id] > *:nth-child(7n+2), [data-bar-id] > *:nth-child(7n+2), [data-line-id] > *:nth-child(7n+2) {
        color: #465a7f; }
    [data-pie-id] > *:nth-child(7n+3), [data-bar-id] > *:nth-child(7n+3), [data-line-id] > *:nth-child(7n+3) {
        color: #5e769f; }
    [data-pie-id] > *:nth-child(7n+4), [data-bar-id] > *:nth-child(7n+4), [data-line-id] > *:nth-child(7n+4) {
        color: #7792bf; }



    #pie, #donut, #bar {
        max-height: 450px; }


    svg {
        width: 100%;
        height: auto;
    }


    ul[data-pie-id] {
        list-style: none;
    }
    .eventPresetView .pieWrapper ul li{
        font-size:1.118rem;
    }
    .eventPresetView .pieWrapper ul li + li{
        margin-top:10px;
    }
    .eventPresetView .pieWrapper ul li span{
        color:#2e2e2e;
    }
    .eventPresetView .pieWrapper ul li span span{
        font-weight: 700;
        font-style: italic;
    }
    .eventPresetView .pieWrapper ul li:before{
        content: "";
        width:17px;
        height:17px;
        border-radius: 50%;
        display:inline-block;
        margin-top:2px;
        margin-left:15px;

    }
    .eventPresetView .pieWrapper .pieInnerWrapper{
        padding:0 30px;
    }
    .eventPresetView .pieWrapper .pieInnerWrapper h2{

        margin:20px 0px;

    }
    .eventPresetView .pieWrapper ul li.notResponded:before{background:#5e769f;}
    .eventPresetView .pieWrapper ul li.respondedPositive:before{background:#465a7f;}
    .eventPresetView .pieWrapper ul li.respondedMaybe:before{background:#7792bf;}
    .eventPresetView .pieWrapper ul li.respondedNegative:before{background:#293b5a;}

    .eventPresetView .pieWrapper ul li.notResponded span .status{color:#5e769f;}
    .eventPresetView .pieWrapper ul li.respondedPositive span .status{color:#465a7f;}
    .eventPresetView .pieWrapper ul li.respondedMaybe span .status{color:#7792bf;}
    .eventPresetView .pieWrapper ul li.respondedNegative span .status{color:#293b5a;}

    .eventPresetView .matchHeight .innerBox{
        height:100%;
    }
    .eventPresetView .eventInfoWrapper{
        padding: 20px 30px;
    }
    .eventPresetView .eventInfoWrapper h2 svg{
        display: inline-block;
        vertical-align: middle;
        width:52px;
        height:52px;
        fill:#293b5a;
        margin-left: 10px;
    }
    .eventPresetView .eventInfoWrapper h2 span{
        display: inline-block;
        vertical-align: middle;
    }
    .eventPresetView .eventInfoWrapper h2 span .date{
        color:#293b5a;
        font-size: 1.059rem;
        font-weight: 400;
    }
    .eventPresetView .mainInfo{
        margin: 20px 0;
    }
    .eventPresetView .mainInfo li{
        display:inline-block;
        vertical-align: middle;
        font-size: 1.059rem;
    }
    .eventPresetView .mainInfo li + li{
        margin-right:15px;
    }
    .eventPresetView .mainInfo li svg{
        display:inline-block;
        vertical-align: middle;
        margin-left: 7px;
        fill:#293b5a;
    }
    .eventPresetView .mainInfo li svg.i_location{
        width:28px;
        height:28px;
    }
    .eventPresetView .mainInfo li svg.i_users{
        width:40px;
        height: 30px;
    }
    .eventPresetView .mainInfo li span{
        display:inline-block;
        vertical-align: middle;
    }
    .eventPresetView .mainInfo li span.liTitle{
        font-weight: 700;
        color:#7791be;
    }
    .eventPresetView .moreInfo{
        background: #f0f0f0;
        padding:15px;
    }
    .eventPresetView .moreInfo li{
        display:inline-block;
        vertical-align: top;
    }
    .eventPresetView .moreInfo li h3{

        margin-bottom: 10px;
    }
    .eventPresetView .moreInfo li + li{
        margin-right: 20px;
    }
    .eventPresetView .bottomPart{
        margin-top: 35px;
    }
    .eventPresetView .ulamDetailes{
        padding:20px 15px;
    }
    .eventPresetView .placeNumbers{
        font-weight: 400;
    }
    .eventPresetView .ulamDetailes h2{
        margin-bottom: 10px;
    }
    .eventPresetView .ulamDetailes h2 svg{
        display: inline-block;
        vertical-align: middle;
        fill: #ff0000;
        width:22px;
        height:22px;
        margin-right: 15px;
    }
    .eventPresetView .ulamDetailes .selectWrap{
        width: 250px;
    }
    .eventPresetView .ulamDetailes .selectWrap select{
        background: #fff;
        color:#293b5a;
        font-size: 0.8824rem;
    }
    .eventPresetView .ulamDetailes label{
        color: #293b5a;
        font-weight: 700;
        font-size:1.059rem;
    }
    .eventPresetView .ulamDetailes .checkboxWrap{
        margin:20px 0;
    }
    .eventPresetView .ulamDetailes .checkboxWrap label{
        color:#4a4a4a;
        font-size: 0.8235rem;
        font-weight: 400;
        margin-right: 7px;
    }
    input[type=checkbox]{
        -webkit-appearance: none;
        -moz-appearance:    none;
        appearance:         none;
        width: 24px;
        height: 24px;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 2;
    }
    input[type=checkbox] + .checkS{
        width: 24px;
        height: 24px;
        border-radius: 50%;
        display: block;
        /* ff3.6+ */
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41, 59, 90, 1)), color-stop(100%, rgba(123, 150, 196, 1)));
        /* safari4+,chrome */
        background: -webkit-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* safari5.1+,chrome10+ */
        background: -o-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* opera 11.10+ */
        background: -ms-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ie10+ */
        background: linear-gradient(90deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* w3c */
        filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4', GradientType=1 );
        /* ie6-9 */
    }
    .eventPresetView .checkboxInnerWrap{
        position: relative;
        display: inline-block;
        vertical-align: middle;

    }
    .eventPresetView .checkboxInnerWrap svg{
        width: 14px;
        height: 10px;
        position: absolute;
        top: calc(50% - 5px);
        right: calc(50% - 7px);
        fill: #fff;
        opacity: 0;
    }
    input[type=checkbox]:checked + .checkS + svg{
        opacity: 1;
    }
    .eventPresetView .panel-title{
        position: relative;;
    }
    .eventPresetView .panel-title svg {
        width: 19px;
        height: 30px;
        position: absolute;
        top: calc(50% - 15px);
        left: 0px;
        fill: #3f5376
    }
    .eventPresetView .panel-heading:not(.collapsed) svg.i_plus_2, .panel-heading.collapsed svg.i_minus {
        display: none;
    }
    .eventPresetView .panel-heading:not(.collapsed) svg.i_minus {
        display: block;
    }
    .eventPresetView .panel-group{
        margin-bottom: 0px;
    }
    .eventPresetView .panel-group .panel{
        border-radius: 0;
    }
    .eventPresetView .panel-default{
        border-bottom-color:#55e4d4!important;
        box-shadow: none;
    }
    .eventPresetView .panel-group .panel+.panel{
        margin-top: 15px;
    }
    .eventPresetView .panel-heading{
        background: #f0f0f0;
    }
    .eventPresetView .panel-default{
        border-color: #f0f0f0;
    }
    .eventPresetView .panel-default>.panel-heading{
        background: #fff;
        border-color: #55e4d4;
    }
    .eventPresetView .panel-default>.panel-heading.collapsed{
        background: #f0f0f0;
    }
    .eventPresetView .panel-group .panel-heading+.panel-collapse>.panel-body{
        border-top:0;
        padding:0;
    }
    .eventPresetView .panel-title>a{
        color: #7a95c2;
        font-weight: 700;
    }
    .eventPresetView .collapsed .panel-title>a{
        color: #293b5a;
        font-weight: 700;
    }
    .eventPresetView .panel-body ul li{
        float: right;
        width: 33.3%;
        padding:15px;
    }
    .eventPresetView .panel-body ul li img{
        max-width: 100%;
    }
    .eventPresetView .panel-body ul li div.imgWrap{
        height:calc(100% - 30px);
        text-align: center;
    }
    .eventPresetView .panel-body ul li div:not(.imgWrap){
        color: #242424;
        font-size: 0.8824rem;
        text-align: center;
        margin-top: 10px;
    }
    .eventPresetView .totalSeats{
        width:100%;
        height:100%;
        background: -moz-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41, 59, 90, 1)), color-stop(100%, rgba(123, 150, 196, 1)));
        background: -webkit-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        background: -o-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        background: -ms-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        background: linear-gradient(90deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4', GradientType=1 );
        text-align: center;
        color:#cdcdcd;
        font-size: 1.118rem;
        padding: 15px 0;
    }
    .eventPresetView .innerTotalSeats{
        display: inline-block;
        text-align: right;
    }
    .eventPresetView .totalSeats .ulamCapacity{
        font-size: 2rem;
        color:#fff;
        font-weight: bold;
        font-style: italic;
        margin-left: 5px;
    }
    .eventPresetView .totalSeats .ulamCapacity + span{
        font-style: italic;
        font-size: 0.9412rem;
    }
    .eventPresetView .ulamLayoutWrapper{
        width:100%;
        overflow: auto;
        /*display: flex;*/
    }
    #ulamLayout{
        width: 720px;
        height:720px;
        background: url("/static/images/layoutBg.jpg") no-repeat right top;
        background-size: contain;
        /*flex-grow: 1;*/
    }
    .eventPresetView .grid{
        width:100%;
        height: 100%;
    }

    .eventPresetView .item{
        display: inline-block;
        padding: 20px;
        position: relative;
        width:32%;
        text-align: center;
    }
    #list-1 .item{
        padding:10px;
    }
    .eventPresetView .item .imgWrap{
        margin-bottom: 20px;
    }
    .eventPresetView .item .imgWrap img{
        max-width: 100%;
    }
    #gridWrap{
        position: relative;
    }
    #gridWrap .item{
        width:auto;
        position: absolute;
        padding: 0;
    }
    #gridWrap .item .rectangle,
    #gridWrap .item .square:not(.wood),
    #gridWrap .item .circle{
        background: #fff;
    }
    .eventPresetView .tableWrap{
        position: relative;
        padding: 3px 3px;
        display: inline-block;
    }
    #gridWrap .item .tableNum{
        color:#314364;
        font-size: 1.3rem;
        font-weight: bold;
    }
    .eventPresetView .rectangle,
    .eventPresetView .square{
        margin:0 auto;
        border: 2px solid #c1bfbf;
        min-width: 30px;
        min-height: 30px;

    }
    .eventPresetView .ellipseTable .rectangle{
        min-width: 25px;
        border-radius: 50%;
    }
    .eventPresetView .seat{
        width:10px;
        height:8px;
        border: 1px solid #000;
        border-radius: 2px;
        display: block;
        background: #fff;
    }
    .eventPresetView .ulamLayoutWrapper{
        margin-top:30px;
    }
    .eventPresetView .circlePrecWrap{
        width:76px;
        height:76px;
        display: inline-block;
        float:right
    }
    .eventPresetView .precentageTxt{
        display: inline-block;
        padding-right: 15px;
        text-align: right;
    }
    .eventPresetView .circlePrecWrap .circle-bg {
        fill: none;
        stroke: #eee;
        stroke-width: 1.8;
    }

    .eventPresetView .circlePrecWrap .circle {
        fill: none;

        stroke-width: 1.8;
        stroke-linecap: round;
        animation: progress 1s ease-out forwards;
    }
    .eventPresetView .seatedPlaces .circle{
        stroke: #ff0000;
    }
    .eventPresetView .unSeatedPlaces .circle{
        stroke: #293b5a;
    }
    @keyframes progress {
        0% {
            stroke-dasharray: 0 100;
        }
    }
    .eventPresetView .circlePrecWrap .percentage {
        fill: #626262;
        font-style: italic;
        font-size: 0.5rem;
        text-anchor: middle;
    }
    .eventPresetView .precentageWrap{
        padding:15px;
        text-align: center;
    }
    .eventPresetView .precentageIcon{
        position: relative;
        margin-right: 5px;
    }
    .eventPresetView .precentageIcon .mainIcon{
        width: 18px;
        height: 16px;
        border-radius: 5px;
        border: 1px solid #fff;
        display: inline-block;
        z-index: 1;
        position: relative;
    }
    .eventPresetView .precentageIcon span:not(.mainIcon){
        width: 24px;
        height: 14px;
        position: absolute;
        top: -1px;
        right: -3px;
        border-radius: 5px 5px 0px 0px;
    }
    .eventPresetView .seatedPlaces .precentageIcon span:not(.mainIcon),
    .eventPresetView .seatedPlaces .precentageIcon .mainIcon{
        background:#ff0000;
    }
    .eventPresetView .unSeatedPlaces .precentageIcon span:not(.mainIcon),
    .eventPresetView .unSeatedPlaces .precentageIcon .mainIcon{
        background:#293b5a;
    }
    .eventPresetView .placesNum{
        color: #4c4c4c;
        font-weight: bold;
        font-size: 1.412rem;
        line-height: 20px;
    }
    .eventPresetView .seatedStatus{
        color:#9b9b9b;
        font-size: 1.059rem;
    }
    .eventPresetView .rectangleTable .seat,
    .eventPresetView .squareTable .seat{
        display: inline-block;
        position: relative;
    }
    .eventPresetView .rectangleTable .seat:before,
    .eventPresetView .squareTable .seat:before{
        content: "";
        width: 6px;
        height: 6px;
        position: absolute;
        background: #fff;
        border: 1px solid #000;
        border-radius: 2px;
    }
    .eventPresetView .rectangleTable .side1 .seat,
    .eventPresetView .squareTable .side1 .seat{
        vertical-align: top;
    }
    .eventPresetView .rectangleTable .side3 .seat,
    .eventPresetView .squareTable .side3 .seat{
        vertical-align: bottom;
    }
    .eventPresetView .rectangleTable .side2 .seat,
    .eventPresetView .rectangleTable .side0 .seat,
    .eventPresetView .squareTable .side2 .seat,
    .eventPresetView .squareTable .side0 .seat{
        width: 8px;
        height: 10px;
        display: block;

    }
    .eventPresetView .rectangleTable .side0 .seat:before,
    .eventPresetView .squareTable .side0 .seat:before{
        left: -2px;
        top: 1px;
    }
    .eventPresetView .rectangleTable .side1 .seat:before,
    .eventPresetView .squareTable .side1 .seat:before{
        left: 1px;
        top: -2px;
    }
    .eventPresetView .rectangleTable .side2 .seat:before,
    .eventPresetView .squareTable .side2 .seat:before{
        top: 1px;
    }
    .eventPresetView .rectangleTable .side3 .seat:before,
    .eventPresetView .squareTable .side3 .seat:before{
        bottom: -2px;
        right: 1px;
    }

    .eventPresetView .rectangleTable .side0 .seat + .seat,
    .eventPresetView .squareTable .side0 .seat + .seat{
        margin-top:3px;
    }
    .eventPresetView .rectangleTable .side1 .seat + .seat,
    .eventPresetView .squareTable .side1 .seat + .seat{
        margin-right:3px;
    }
    .eventPresetView .rectangleTable .side2 .seat + .seat,
    .eventPresetView .squareTable .side2 .seat + .seat{
        margin-top:3px;
    }
    .eventPresetView .rectangleTable .side3 .seat + .seat,
    .eventPresetView .squareTable .side3 .seat + .seat{
        margin-right:3px;
    }

    .eventPresetView .rectangleTable .tableSide,
    .eventPresetView .squareTable .tableSide{
        position: absolute;
        text-align: center;
    }
    .eventPresetView .rectangleTable .side0,
    .eventPresetView .squareTable .side0{
        left:100%;
        top: 50%;
        transform: translate(0,-50%);
    }
    .eventPresetView .rectangleTable .side1,
    .eventPresetView .squareTable .side1{
        top:100%;
        right: 50%;
        transform: translate(50%,0);
        width:calc(100% - 6px);
        height:20px
    }
    .eventPresetView .rectangleTable .side2,
    .eventPresetView .squareTable .side2{
        right:100%;
        top: 50%;
        transform: translate(0,-50%) rotate(180deg);
    }
    .eventPresetView .rectangleTable .side3,
    .eventPresetView .squareTable .side3{
        /*bottom: 100%;*/
        right: 50%;
        transform: translate(50%,0);
        width:calc(100% - 6px);

    }
    .eventPresetView .itemLabel{
        margin-top: 15px;
    }
    .eventPresetView .circleTable .circle{
        margin: 0 auto;
        border: 2px solid #c1bfbf;
        min-width: 30px;
        min-height: 30px;
        border-radius: 50%;
    }
    .eventPresetView .circleTable .circle .seat{
        position: absolute;
        top: 40%;
        left: 40%;

    }
    #gridWrap .seat,
    #gridWrap .seat:before{
        background:#fff!important;
    }
    #gridWrap .seat.notComing:before,
    #gridWrap .seat.notComing{
        background: #ff1010!important;
    }
    #gridWrap .seat.reserve:before,
    #gridWrap .seat.reserve{
        background: #0034ff !important;
    }
    #gridWrap .seat.confirmed:before,
    #gridWrap .seat.confirmed{
        background: #47ce41!important;
    }
    #gridWrap .seat.maybe:before,
    #gridWrap .seat.maybe{
        background: #FAFF04!important;
    }
    #gridWrap .seat.notResponded:before,
    #gridWrap .seat.notResponded{
        background: #A2A2A2!important;
    }

    .eventPresetView .circleTable .seat:before{
        content: "";
        width: 6px;
        height: 6px;
        position: absolute;
        background: #fff;
        border: 1px solid #000;
        border-radius: 2px;
        position: absolute;
        bottom:-2px;
        right:1px;
    }
    .eventPresetView .ellipseTable .side0 .seat:first-child{    transform: rotate(-21deg) translate(-2px);}
    .eventPresetView .ellipseTable .side0 .seat:last-child{    transform: rotate(21deg) translate(-2px);}
    .eventPresetView .ellipseTable .side2 .seat:first-child{transform: rotate(-21deg) translate(-2px);}
    .eventPresetView .ellipseTable .side2 .seat:last-child{    transform: rotate(21deg) translate(-2px);}
    .eventPresetView .squareTable.wood .square{
        background:#e1e1e1;
    }
    #gridWrap .itemLabel{
        margin-top: -10px;
        font-weight: bold;
        background-color: #ffffff;
    }
    .eventPresetView .item .resizeIcon{ display:none }
    .eventPresetView .item.hovered .resizeIcon{
        display: block;
        z-index: 1;
        position: absolute;
    }
    .eventPresetView .item.hovered .resizeIcon i{
        font-size: 21px;
        margin-top: -8px;
        position: absolute;
        margin-right: -16px;
    }

    .eventPresetView .item .rotateIcon,
    .eventPresetView .item .editIcon,
    .eventPresetView .item .deleteIcon{ display:none }
    .eventPresetView .item.hovered .rotateIcon{
        display: block;
        z-index: 1;
        position: absolute;
        top:-10px;
        left:0px;
        font-size: 23px;
    }
    .eventPresetView .item.hovered .deleteIcon{
        display: block;
        z-index: 1;
        top: -28px;
        position: absolute;
        font-size: 23px;
        right: -10px;
    }
    .eventPresetView .item.hovered .editIcon{
        display: block;
        z-index: 1;
        bottom: -17px;
        position: absolute;
        font-size: 23px;
        left: -17px;
    }
    .eventPresetView .item.hovered .rotateIcon i{
        font-size: 21px;
        margin-top: -12px;
        position: absolute;
        margin-right: -4px;
    }
    .svg_icon{
        height:100px;
        fill: #c1bfbf
    }
    .squareTable{
        z-index: 9999999    ;
    }
    #gridWrap [data-table-usage]:after{
        content: attr(data-table-usage);
        position: absolute;
        bottom: 4px;
        right: 7px;
        font-weight: bold;
        opacity: 0.7;
        font-size: 11px;
    }
    #gridWrap [data-table-usage][data-shape="circle"]:after{
        bottom: -22px;
        color: white;
        opacity: 1;
        text-shadow: 1px 0 black, 0 1px black, -1px 0 black, 0 -1px black;
    }
    @media only screen and (max-width:769px) and (max-height: 1025px) {
        .eventSummary{
            margin-bottom: 35px;
        }
    }
</style>
